import React, { useState, useEffect } from "react";
import { db } from "../database/firebase";
import { updateDoc, doc, getDoc, addDoc, collection } from "firebase/firestore";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import ListaUsuarios from "../component/ListaUsuarios";
import { doCreateUserWithEmailAndPassword } from "../database/auth";
import ListaClasesRealtime from "../component/ListaClasesCompradas";
import ListaClasesGrabadas from "../component/ListaClasesGrabadas";
import { CopyToClipboard } from "react-copy-to-clipboard";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import {
  registrarAlumnoSchema,
  modificarClaseSchema,
  agregarContenidoSchema,
} from "../component/Validation";
import { yupResolver } from "@hookform/resolvers/yup";
import { serverTimestamp } from "firebase/firestore";

const Admin = () => {
  // Estado de formulario
  const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false);
  // Estados de clase a la venta
  const [claseSeleccionada, setClaseSeleccionada] = useState("claseGrabada");
  // Estados de contenido de las clases
  const [claseCompradaSeleccionada, setClaseCompradaSeleccionada] =
    useState("claseGrabada");
  // Estados de clase
  const [clase, setClase] = useState(null);
  const [copyStatus, setCopyStatus] = useState(false);
  // Estado de calendario
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, "clases", claseSeleccionada);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setClase(docSnap.data());
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error obteniendo el documento:", error);
      }
    };
    fetchData();
  }, [claseSeleccionada, isSubmitSuccessful]);

  console.log(clase === null ? "Cargando..." : clase);

  const {
    register: registerCurso,
    handleSubmit: handleSubmitCurso,
    reset: resetCurso,
    formState: { errors: errorsCurso },
  } = useForm({
    resolver: yupResolver(modificarClaseSchema),
    defaultValues: {
      titulo: "",
      descripcion: "",
      precio: "",
      moneda: "",
      link_binance: "",
      link_mp: "",
      link_hotmart: "",
    },
  });

  const {
    register: registerAlumno,
    watch,
    handleSubmit: handleSubmitAlumno,
    reset: resetAlumno,
    formState: { errors: errorsAlumno },
  } = useForm({
    resolver: yupResolver(registrarAlumnoSchema),
    defaultValues: {
      nombre: "",
      email: "",
      password: "",
      telefono: "",
    },
  });
  const password = watch("password");

  const {
    register: registerCursoComprado,
    handleSubmit: handleSubmitCursoComprado,
    reset: resetCursoComprado,
    formState: { errors: errorsCursoComprado },
  } = useForm({
    resolver: yupResolver(agregarContenidoSchema),
    defaultValues: {
      titulo: "",
      descripcion: "",
      link: "",
      alumno: "",
    },
  });

  const onCopyText = () => {
    setCopyStatus(true);
    setTimeout(() => setCopyStatus(false), 2000); // Reset status after 2 seconds
  };

  useEffect(() => {
    if (isSubmitSuccessful) {
      resetCurso();
      resetAlumno();
      resetCursoComprado();
      setIsSubmitSuccessful(false);
    }
  }, [
    isSubmitSuccessful,
    resetAlumno,
    resetCurso,
    resetCursoComprado,
    claseSeleccionada,
    claseCompradaSeleccionada,
  ]);

  const onSubmitCurso = async (data) => {
    console.log(data);
    await modifyCourse(data);
  };

  const onSubmitAlumno = async (data) => {
    console.log(data);
    await saveNewAlumno(data);
  };

  const onSubmitCursoComprado = async (data) => {
    console.log(data);
    await addBoughtCourse(data);
  };

  const modifyCourse = async (dataToSubmit) => {
    console.log("data to submit:", dataToSubmit);
    if (Object.keys(dataToSubmit).length === 0) {
      console.log("No se pudo publicar el curso, no hay datos");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo publicar el curso, no hay datos",
      });
      return;
    }
    try {
      await updateDoc(doc(db, "clases", claseSeleccionada), dataToSubmit);
      console.log("El curso fue publicado exitosamente");
      Swal.fire({
        icon: "success",
        title: "Guardado",
        text: "El curso se ha guardado correctamente",
      });
      resetCurso();
    } catch (error) {
      console.error("Error al publicar el curso", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un error al guardar el curso: " + error,
      });
    }
  };

  const saveNewAlumno = async (dataAlumno) => {
    console.log(dataAlumno);
    if (Object.keys(dataAlumno).length === 0) {
      console.log("No se pudo registrar el alumno, no hay datos");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo registrar el alumno, no hay datos",
      });
      throw new Error("No se pudo registrar el alumno, no hay datos");
    }
    try {
      const success = await doCreateUserWithEmailAndPassword(
        dataAlumno.email,
        dataAlumno.password,
        dataAlumno.telefono,
        dataAlumno.nombre
      );

      if (success) {
        console.log("El alumno fue registrado exitosamente");
        Swal.fire({
          icon: "success",
          title: "Guardado",
          text: "El alumno se ha registrado correctamente",
        });
        resetAlumno();
      } else {
        throw new Error("No se pudo crear el usuario");
      }
    } catch (error) {
      console.error("Error al registrar el usuario", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un error al registrar el usuario: " + error,
      });
    }
  };

  const addBoughtCourse = async (dataToSubmit) => {
    console.log("data to submit:", dataToSubmit);
    if (Object.keys(dataToSubmit).length === 0) {
      console.log("No se pudo publicar el curso, no hay datos");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo publicar el curso, no hay datos",
      });
    }
    try {
      if (dataToSubmit.link) {
        const url = new URL(dataToSubmit.link);
        let videoId;
        if (url.hostname === "youtu.be") {
          videoId = url.pathname.slice(1);
        } else if (
          url.hostname === "www.youtube.com" ||
          url.hostname === "youtube.com"
        ) {
          if (url.pathname === "/watch") {
            videoId = url.searchParams.get("v");
          } else if (url.pathname.startsWith("/embed/")) {
            videoId = url.pathname.slice(7);
          } else if (url.pathname.startsWith("/v/")) {
            videoId = url.pathname.slice(3);
          }
        }
        if (videoId) {
          const embedLink = `https://www.youtube.com/embed/${videoId}`;
          dataToSubmit.link = embedLink;
        }
      }

      dataToSubmit.timestamp = serverTimestamp();
      dataToSubmit.fecha = date;

      // Obtén una referencia al documento en la colección 'contenidoClases'
      const docRef = doc(
        db,
        "contenidoClases",
        claseCompradaSeleccionada + "Doc"
      );

      // Obtén una referencia a la subcolección
      const claseRef = collection(docRef, claseCompradaSeleccionada);

      // Agrega los datos a la subcolección
      await addDoc(claseRef, dataToSubmit);

      console.log("El curso fue publicado exitosamente");
      Swal.fire({
        icon: "success",
        title: "Guardado",
        text: "El curso se ha guardado correctamente",
      });
      resetCursoComprado();
    } catch (error) {
      console.error("Error al publicar el curso", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un error al guardar el curso: " + error,
      });
    }
  };

  const handleClaseChange = () => {
    if (claseSeleccionada === "claseGrabada") {
      setClaseSeleccionada("claseRealtime");
    } else {
      setClaseSeleccionada("claseGrabada");
    }
  };

  const handleClaseCompradaChange = () => {
    if (claseCompradaSeleccionada === "claseGrabada") {
      setClaseCompradaSeleccionada("claseRealtime");
    } else {
      setClaseCompradaSeleccionada("claseGrabada");
    }
  };

  return (
    <div className="main flex flex-col">
      <div className="main_platform_block mt-[50px] mx-auto flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col sm:flex-col justify-center max-w-[1240px] ">
        <div className="flex flex-col w-full">
          <div className="register_main">
            <div className="register_main_block my-0 mx-auto flex flex-row justify-center max-w-[1240px]">
              <div className="register_form_container max-w-[500px] mx-auto w-full">
                <div className="register_block w-full pb-[2px] px-auto bg-[#444b5d] rounded-[8px] pt-[30px]">
                  <div className="register_title mb-[32px] font-[700] text-[46px] leading-[48px] text-center text-white tracking-tight">
                    Registrar un alumno
                  </div>
                  <div className="register_tab">
                    <form
                      onSubmit={handleSubmitAlumno(onSubmitAlumno)}
                      class="login_form"
                    >
                      <div class="register_input relative max-w-[366px] w-full mx-auto mb-[24px]">
                        <label class="register_label absolute top-[-8px] left-[10px] bg-[#444b5d] color-white/30 px-[6px] text-[14px] leading-[18px] z-10 text-white/30 font-bold">
                          Nombre
                        </label>
                        <input
                          autocomplete="off"
                          type="text"
                          name="nombre"
                          required="1"
                          placeholder="Nombre"
                          {...registerAlumno("nombre")}
                          class="register_input_value w-full h-[48px] border border-white/10 border-[1px] rounded-[4px] py-[8px] pr-[8px] pl-[14px] text-[16px] leading-[20px] bg-[#444b5d] text-white/80 placeholder:text-white/20 outline-none"
                        ></input>
                        {errorsAlumno.nombre && (
                          <div class="text-red-500">
                            <p>{errorsAlumno.nombre.message}</p>
                          </div>
                        )}
                      </div>
                      <div class="register_input relative max-w-[366px] w-full mx-auto mb-[24px]">
                        <label class="register_label absolute top-[-8px] left-[10px] bg-[#444b5d] color-white/30 px-[6px] text-[14px] leading-[18px] z-10 text-white/30 font-bold">
                          Correo electrónico
                        </label>
                        <input
                          autocomplete="off"
                          type="email"
                          name="email"
                          required="1"
                          placeholder="Email"
                          {...registerAlumno("email")}
                          class="register_input_value w-full h-[48px] border border-white/10 border-[1px] rounded-[4px] py-[8px] pr-[8px] pl-[14px] text-[16px] leading-[20px] bg-[#444b5d] text-white/80 placeholder:text-white/20 outline-none"
                        ></input>
                        {errorsAlumno.email && (
                          <div class="text-red-500">
                            <p>{errorsAlumno.email.message}</p>
                          </div>
                        )}
                      </div>
                      <div class="register_input relative max-w-[366px] w-full mx-auto mb-[24px]">
                        <label class="register_label absolute top-[-8px] left-[10px] bg-[#444b5d] color-white/30 px-[6px] text-[14px] leading-[18px] z-10 text-white/30 font-bold">
                          Contraseña
                        </label>

                        <div class="flex items-center">
                          <input
                            autocomplete="off"
                            type="text"
                            name="password"
                            required="1"
                            placeholder="Contraseña"
                            {...registerAlumno("password")}
                            class="register_input_value w-full h-[48px] border border-white/10 border-[1px] rounded-[4px] mr-2 py-[8px] pr-[8px] pl-[14px] text-[16px] leading-[20px] bg-[#444b5d] text-white/80 placeholder:text-white/20 outline-none"
                          ></input>
                          {copyStatus && (
                            <p class="text-white absolute right-[-180px] p-2 font-bold bg-btngray/70 rounded ">
                              Copied to clipboard!
                            </p>
                          )}
                          <CopyToClipboard text={password} onCopy={onCopyText}>
                            <button
                              type="button"
                              onClick={onCopyText}
                              title="Copiar"
                              class="hover:bg-white/10 shadow-btn-shadow shadow-white/10 transition-all duration-300 rounded-[4px]"
                            >
                              <div class="flex items-center justify-center border border-white/10 border-[1px] rounded-[4px] p-[7px] outline-none">
                                <svg
                                  className="w-8 h-8 text-white"
                                  aria-hidden="true"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M15 4h3c.6 0 1 .4 1 1v15c0 .6-.4 1-1 1H6a1 1 0 0 1-1-1V5c0-.6.4-1 1-1h3m0 3h6m-6 5h6m-6 4h6M10 3v4h4V3h-4Z"
                                  />
                                </svg>
                              </div>
                            </button>
                          </CopyToClipboard>
                        </div>
                        {errorsAlumno.password && (
                          <div class="text-red-500">
                            <p>{errorsAlumno.password.message}</p>
                          </div>
                        )}
                      </div>
                      <div class="register_input relative max-w-[366px] w-full mx-auto mb-[24px]">
                        <label class="login_label absolute top-[-8px] left-[10px] bg-[#444b5d] color-white/30 px-[6px] text-[14px] leading-[18px] z-10 text-white/30 font-bold">
                          Teléfono
                        </label>
                        <input
                          autocomplete="off"
                          type="text"
                          name="telefono"
                          required="1"
                          placeholder="Teléfono"
                          {...registerAlumno("telefono")}
                          class="login_input_value w-full h-[48px] border border-white/10 border-[1px] rounded-[4px] py-[8px] pr-[8px] pl-[14px] text-[16px] leading-[20px] bg-[#444b5d] text-white/80 placeholder:text-white/20 outline-none"
                        ></input>
                        {errorsAlumno.telefono && (
                          <div class="text-red-500">
                            <p>{errorsAlumno.telefono.message}</p>
                          </div>
                        )}
                      </div>
                      <button
                        type="submit"
                        className="btn flex items-center justify-center bg-[#4a8ded] rounded-lg text-white font-bold text-base py-[19px] shadow-btn-shadow-blue shadow-btnblue/25 mx-auto mb-[38px] max-w-[366px] w-full radius-[4px] hover:bg-[#2d7bd9] transition-all duration-300"
                      >
                        Registrar alumno
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="border border-1 border-white/10 bg-btngray/50 w-full mt-[20px] p-[10px] max-h-[400px]">
            <h1 className="text-white text-center font-bold text-[40px] leading-[48px]">
              Cuentas de alumnos
            </h1>
            <ListaUsuarios />
          </div>
        </div>
        <div className="main_platform_container max-w-[620px] w-full pl-0 md:pl-[90px] sm:pl-[45px]">
          <div className="flex flex-col items-center justify-center">
            <span className="register_title font-[700] text-[46px] leading-[48px] text-center text-white tracking-tight mt-5 lg:mt-0">
              Modificar venta de clase
            </span>
            <div className="relative w-full p-4 rounded-lg flex justify-center">
              <div className="relative w-[320px] h-12 bg-[#191c29] rounded-full overflow-hidden border border-1 border-white/10 flex items-center">
                <button
                  onClick={handleClaseChange}
                  className={`flex items-center justify-center w-[155px] px-4 py-2 bg-blue-500 text-white rounded-full transition-transform duration-300 ease-in-out cursor-pointer absolute left-1/2 transform ${
                    claseSeleccionada === "claseGrabada"
                      ? "-translate-x-full"
                      : "translate-x-0"
                  } hover:bg-blue-400`}
                >
                  {claseSeleccionada === "claseGrabada"
                    ? "Clase grabada"
                    : "Clase en vivo"}
                </button>
              </div>
            </div>
          </div>
          <form
            class="login_form flex flex-col"
            onSubmit={handleSubmitCurso(onSubmitCurso)}
          >
            {claseSeleccionada === "claseRealtime" && (
              <div class="flex flex-col">
                <label class="text-white/60 font-bold tracking-tight text-[16px] leading-[20px]">
                  Numero de cupos
                </label>
                <input
                  placeholder={
                    clase && clase.cupos ? `${clase.cupos}` : "Cargando..."
                  }
                  rows={1}
                  cols={1}
                  class="main_text bg-primary border-[1px] border-white/10 rounded-[4px] resize-none px-[10px] font-bold text-white md:text-[20px] lg:text-[20px] xl:text-[32px] 2xl:text-[32px] mb-[6px] mr-[24px] leading-[56px] tracking-tight"
                  required={
                    claseSeleccionada === "claseRealtime" ? true : false
                  }
                  {...registerCurso("cupos")}
                ></input>
                {errorsCurso.cupos && (
                  <div class="text-red-500">
                    <p>{errorsCurso.cupos.message}</p>
                  </div>
                )}
              </div>
            )}
            <label class="text-white/60 font-bold tracking-tight text-[16px] leading-[20px]">
              Título de clase
            </label>
            <textarea
              placeholder={clase ? clase.titulo : "Cargando..."}
              rows={1}
              cols={1}
              class="main_text bg-primary border-1 border-white/10 rounded-[4px] resize-none font-bold text-white md:text-[20px] lg:text-[20px] xl:text-[32px] 2xl:text-[32px] mb-[6px] mr-[24px] leading-[56px] tracking-tight scrollbar scrollbar-thumb-rounded-full scrollbar-thumb-[#4a8ded] scrollbar-track-[#444b5d] scrollbar-track-rounded"
              required="1"
              {...registerCurso("titulo")}
            ></textarea>
            {errorsCurso.titulo && (
              <div class="text-red-500">
                <p>{errorsCurso.titulo.message}</p>
              </div>
            )}
            <label class="text-white/60 font-bold tracking-tight text-[16px] leading-[20px]">
              Descripción
            </label>
            <textarea
              rows={8}
              placeholder={clase ? clase.descripcion : "Cargando..."}
              class="main_subtext text-white/60 md:text-[14px] lg:text-[14px] xl:text-[16px] 2xl:text-[16px] leading-[24px] mr-[24px] mb-[4px] bg-primary border-1 border-white/10 rounded-[4px] resize-y"
              required="1"
              {...registerCurso("descripcion")}
            ></textarea>
            {errorsCurso.descripcion && (
              <div class="text-red-500">
                <p>{errorsCurso.descripcion.message}</p>
              </div>
            )}
            <div class="flex space-x-2 mb-10">
              <div class="flex flex-col max-w-[200px]">
                <label class="text-white/60 font-bold tracking-tight text-[16px] leading-[20px]">
                  Precio
                </label>
                <input
                  placeholder={clase ? clase.precio : "Cargando..."}
                  class="precio_curso font-bold text-white md:text-[20px] lg:text-[20px] xl:text-[24px] 2xl:text-[20px] mr-[18px] leading-[56px] tracking-tight antialiased bg-primary border border-1 border-white/10 rounded-[4px] w-[100px] pl-2"
                  required="1"
                  {...registerCurso("precio")}
                ></input>
                {errorsCurso.precio && (
                  <div class="text-red-500 mb-[-20px]">
                    <p>{errorsCurso.precio.message}</p>
                  </div>
                )}
              </div>
              <div class="flex flex-col max-w-[200px]">
                <label class="text-white/60 font-bold tracking-tight text-[16px] leading-[20px]">
                  Moneda
                </label>
                <input
                  placeholder={clase ? clase.moneda : "Cargando..."}
                  class="text-white bg-primary border border-1 border-white/10 rounded-[4px] w-[100px] p-4"
                  required="1"
                  {...registerCurso("moneda")}
                ></input>
                {errorsCurso.moneda && (
                  <div class="text-red-500 mb-[-20px]">
                    <p>{errorsCurso.moneda.message}</p>
                  </div>
                )}
              </div>
            </div>
            <div class="flex flex-col space-y-5">
              <input
                placeholder="Link de pago BINANCE"
                class="btn bg-btnyellow/50 rounded-[4px] p-18 text-white text-base ml-auto py-4 px-14 shadow-btn-shadow shadow-btnyellow/25 w-full placeholder:text-white/50 placeholder:font-bold"
                {...registerCurso("link_binance")}
              ></input>
              {errorsCurso.link_binance && (
                <div class="text-red-500">
                  <p>{errorsCurso.link_binance.message}</p>
                </div>
              )}
              <input
                placeholder="Link de pago Mercado Pago"
                class="btn bg-btnblue/50 rounded-[4px] p-18 text-white text-base ml-auto py-4 px-14 shadow-btn-shadow shadow-btnblue/25 w-full placeholder:text-white/50 placeholder:font-bold"
                {...registerCurso("link_mp")}
              ></input>
              {errorsCurso.link_mp && (
                <div class="text-red-500">
                  <p>{errorsCurso.link_mp.message}</p>
                </div>
              )}
              <input
                placeholder="Link de pago Debito / Credito"
                class="btn bg-btngray rounded-[4px] p-18 text-white text-base ml-auto py-4 px-14 shadow-btn-shadow shadow-btngray/25 w-full placeholder:text-white/50 placeholder:font-bold"
                {...registerCurso("link_hotmart")}
              ></input>
              {errorsCurso.link_hotmart && (
                <div class="text-red-500">
                  <p>{errorsCurso.link_hotmart.message}</p>
                </div>
              )}
            </div>
            <div class="flex">
              <div class="flex flex-col mx-auto my-auto justify-center">
                <button
                  class="btn bg-btngreen rounded-lg text-white font-bold text-base shadow-btn-shadow shadow-btngreen/25 w-full py-6 px-12 my-5 hover:bg-btngreen/80 transition-all duration-300"
                  type="submit"
                >
                  Subir
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="border-t border-white/10 mx-[150px] mt-[50px]"></div>
      <div class="mt-[50px] mx-auto flex flex-col w-full 2xl:flex-row xl:flex-row lg:flex-row md:flex-col sm:flex-col justify-center max-w-[1240px] mb-[50px] mx-auto">
        <div className="w-full lg:w-1/2 flex flex-col">
          <div className="border border-1 border-white/10 bg-btngray/50 w-full p-[10px] max-h-[300px] rounded-[4px]">
            <h1 className="text-white text-center font-bold text-[40px] leading-[48px] mb-[10px]">
              Clases 1 a 1
            </h1>
            <div className="w-full">
              <ListaClasesRealtime />
            </div>
          </div>
          <div className="border border-1 border-white/10 bg-btngray/50 w-full mt-[20px] p-[10px] max-h-[300px] overflow-y-auto rounded-[4px] h-full mx-auto scrollbar scrollbar-thumb-rounded-full scrollbar-thumb-[#4a8ded] scrollbar-track-[#444b5d] scrollbar-track-rounded">
            <h1 className="text-white text-center font-bold text-[40px] leading-[48px] mb-[10px]">
              Clases grabadas
            </h1>
            <div className="w-full">
              <ListaClasesGrabadas />
            </div>
          </div>
        </div>

        <div class="mx-auto justify-center w-full pl-0 md:pl-[90px] sm:pl-[45px] max-w-[620px] w-full mt-[20px] lg:mt-0">
          <div className="register_title mb-[32px] font-[700] text-[46px] leading-[48px] text-center text-white tracking-tight">
            Agregar contenido clase
          </div>
          <div class="flex flex-col justify-center items-center mb-[32px]">
            <div className="relative w-[320px] h-12 bg-[#191c29] rounded-full overflow-hidden border border-1 border-white/10 flex items-center">
              <button
                onClick={handleClaseCompradaChange}
                className={`flex items-center justify-center w-[155px] px-4 py-2 bg-blue-500 text-white rounded-full transition-transform duration-300 ease-in-out cursor-pointer absolute left-1/2 transform ${
                  claseCompradaSeleccionada === "claseGrabada"
                    ? "-translate-x-full"
                    : "translate-x-0"
                } hover:bg-blue-400`}
              >
                {claseCompradaSeleccionada === "claseGrabada"
                  ? "Clase grabada"
                  : "Clase en vivo"}
              </button>
            </div>
          </div>
          <form
            class="login_form flex flex-col"
            onSubmit={handleSubmitCursoComprado(onSubmitCursoComprado)}
          >
            <label class="text-white/60 font-bold tracking-tight text-[16px] leading-[20px]">
              Título de la clase
            </label>
            <textarea
              placeholder="Titulo de la clase"
              rows={1}
              cols={1}
              class="main_text bg-primary border-1 border-white/10 rounded-[4px] resize-none font-bold text-white md:text-[20px] lg:text-[20px] xl:text-[32px] 2xl:text-[32px] mb-[6px] mr-[24px] leading-[56px] tracking-tight"
              required="1"
              {...registerCursoComprado("titulo")}
            ></textarea>
            {errorsCursoComprado.titulo && (
              <div class="text-red-500">
                <p>{errorsCursoComprado.titulo.message}</p>
              </div>
            )}
            <label class="text-white/60 font-bold tracking-tight text-[16px] leading-[20px]">
              Descripción o contenido
            </label>
            <textarea
              rows={8}
              placeholder="Descripción o contenido"
              class="main_subtext text-white/60 md:text-[14px] lg:text-[14px] xl:text-[16px] 2xl:text-[16px] leading-[24px] mr-[24px] mb-[4px] bg-primary border-1 border-white/10 rounded-[4px] resize-y"
              required="1"
              {...registerCursoComprado("descripcion")}
            ></textarea>
            {errorsCursoComprado.descripcion && (
              <div class="text-red-500">
                <p>{errorsCursoComprado.descripcion.message}</p>
              </div>
            )}
            {claseCompradaSeleccionada === "claseRealtime" ? (
              <label class="text-white/60 font-bold tracking-tight text-[16px] leading-[20px]">
                Link de Zoom o similares
              </label>
            ) : (
              <label class="text-white/60 font-bold tracking-tight text-[16px] leading-[20px]">
                Link de YouTube
              </label>
            )}

            <textarea
              rows={1}
              cols={1}
              placeholder={
                (claseCompradaSeleccionada === "claseGrabada" &&
                  "Link de YouTube") ||
                "Link de Zoom o similares"
              }
              class="main_subtext text-white/60 resize-none md:text-[14px] lg:text-[14px] xl:text-[16px] 2xl:text-[16px] leading-[24px] mr-[24px] mb-[4px] bg-primary border-1 border-white/10 rounded-[4px]"
              required="1"
              {...registerCursoComprado("link")}
            ></textarea>
            {errorsCursoComprado.link && (
              <div class="text-red-500">
                <p>{errorsCursoComprado.link.message}</p>
              </div>
            )}

            {claseCompradaSeleccionada === "claseRealtime" && (
              <div
                class={
                  claseCompradaSeleccionada === "claseRealtime"
                    ? "transition-opacity duration-300 ease-in-out opacity-100 flex flex-col"
                    : "transition-opacity duration-300 ease-in-out opacity-0"
                }
              >
                <label class="text-white/60 font-bold tracking-tight text-[16px] leading-[20px] mb-[3px] mt-[6px]">
                  Nombre del alumno
                </label>
                <textarea
                  rows={1}
                  cols={1}
                  placeholder="Nombre del alumno"
                  class="main_subtext text-white/60 resize-none md:text-[14px] lg:text-[14px] xl:text-[16px] 2xl:text-[16px] leading-[24px] mr-[24px] mb-[4px] bg-primary border-1 border-white/10 rounded-[4px]"
                  {...registerCursoComprado("alumno")}
                ></textarea>
                <label class="text-white/60 font-bold tracking-tight text-[16px] leading-[20px] mb-[3px] mt-[6px]">
                  Seleccionar fecha y hora de la clase
                </label>
                <div class="btn bg-btnblue rounded-lg font-bold text-base shadow-btn-shadow shadow-btnblue/25 hover:bg-btnblue/80 transition-all duration-300 rounded-[4px] mr-[24px]">
                  <div class="flex flex-col mx-auto my-auto justify-center">
                    <DateTimePicker
                      onChange={setDate}
                      value={date}
                      minDate={new Date()}
                    />
                  </div>
                </div>
              </div>
            )}

            <div class="flex">
              <div class="flex flex-col mx-auto my-auto justify-center">
                <button class="btn bg-btngreen rounded-lg text-white font-bold text-base shadow-btn-shadow shadow-btngreen/25 w-full py-6 px-12 my-5 hover:bg-btngreen/80 transition-all duration-300">
                  Subir
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Admin;
